import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../../../common/constants/pathVariables';
import {
  EoeInvitationAcceptance,
  getEmployeeInvitationAcceptanceStateFromSession,
} from '../../../components/EoeInvitationAcceptance/EoeInvitationAcceptance.js';
import { PreAuthHeader } from '../../../components/PreAuthHeader/PreAuthHeader';

export const EoeInvitationAcceptancePath = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { individualDetails, invitedEmail } = location.state ?? {};
  const employeeInvitationAcceptanceState = getEmployeeInvitationAcceptanceStateFromSession();

  useEffect(() => {
    if (!individualDetails) {
      navigate(paths.EMPLOYEE_HOME);
    }
  }, [individualDetails, navigate]);

  return (
    <>
      <PreAuthHeader isEoe={true} individualDetails={individualDetails} />
      <EoeInvitationAcceptance
        employeeInvitationAcceptanceState={employeeInvitationAcceptanceState}
        invitedEmail={invitedEmail}
      />
    </>
  );
};
